import { HttpService } from "@/core";
import { FileReq } from "@/core/services/biz-file.interface";

export class PaymentFlowService {

  static useInvoiceStatusChangeApi() {
    const api = (files: FileReq[], bizId: string, bizType: string, bizFileType: string = '', cancelPaymentDesc : string = '',status : string = '',columnName? ) =>
      HttpService.axios({
        method: "POST",
        url: `/common_api/fundStatusChange`,
        data: {bizId, bizType, fileObjAReq: { bizFiles: files, bizId, bizType:bizFileType }, cancelPaymentDesc, status ,columnName },
      });
    return HttpService.useRequest(api);
  }


  // 通用接口-资金流
  static useInvoiceStatusChangeApis() {
    const api = (files: FileReq[], bizId: string,bizIds: string, bizType: string, bizFileType: string = '', cancelPaymentDesc : string = '',status : string = '',columnName? ) =>
      HttpService.axios({
        method: "POST",
        url: `/common_api/fundStatusChange`,
        data: {
          bizId,
          bizIds,
          bizType, 
          fileObjAReq: {
            bizFiles: files, 
            bizId,
            bizIds, 
            bizType:bizFileType 
          },
          cancelPaymentDesc, 
          status ,
          columnName 
        },
      });
    return HttpService.useRequest(api);
  }


}
